<div class="flex flex-col">
  <div class="bg-grey-200 page-padding-y page-padding-x">
    <h3 id="h-IEC-Create-Ballot">Committee Internal Ballot</h3>
  </div>

  <form  [formGroup]="ballotForm" class="h-full bg-grey-100">
    <div class="pt-6 pb-6 page-padding-x">
      <div class="flex flex-col gap-6">

        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="reference-Field" id ="reference-Label">
              Reference
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1" id="reference-Field">
              <input type="text"
                     id="reference-Input"
                     placeholder=""
                     aria-label="Number"
                     matInput
                     formControlName="referenceCtrl"
                    >
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row justify-start gap-6">
          <div class="w-full">
            <label class="mb-2 body-large-bold" for="title-Field" id="title-Label">
              Question
            </label>
            <mat-form-field appearance="outline" class="relative w-full mt-1" id="title-Field">
              <input type="text"
                     id="title-Input"
                     placeholder=""
                     aria-label="Number"
                     matInput
                     formControlName="questionCtrl"
                    >

            </mat-form-field>
          </div>
        </div>

        <app-select-committee formControlName="committeeCtrl" [voteOptions]="voteOptions"></app-select-committee>

        <div class="flex flex-row items-start gap-6">
          <app-ballot-create-dates class="flex-1" (selectedDatesChange)="handleSelectedDatesChange($event)"></app-ballot-create-dates>
        </div>

        <div class="flex flex-row items-start gap-6">
          <files-upload class="flex-1"  title="Attach a supporting document" (onFilesUpload)="addSupportingDocument($event)" accept=".pdf,.doc,.docx"></files-upload>
        </div>

        <div class="flex justify-end gap-6 mt-5 mr-10 mb-72">
          <button class="px-8 py-3 border border-black btn btn-neutral" id="Cancel-Button" (click)="redirectToCreateBallotPage()">Cancel</button>
          <button class="px-8 py-3 btn btn-primary" [disabled]="ballotForm.invalid || hasInvalidFilesAttached" id="Create-Ballot-Button" (click)="createBallot()">Create Ballot</button>
        </div>
      </div>
    </div>
  </form>

</div>
